// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-module--container--1-Omb","about":"nav-module--about--23YtU","active":"nav-module--active--2UkT2"};